import { AttachmentLogsSliderController } from './attachment-logs-slider.controller'

function attachmentLogsSlider () {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: '/posts/directives/attachment-logs-slider/attachment-logs-slider-directive.html?$$REVISION$$',
    controller: AttachmentLogsSliderController
  }
}

export { attachmentLogsSlider }
